import Vue from 'vue'

import router from './router'
import store from './store'
import Router from './component/Router.vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { closeSpashscreen } from '../util'
import './_asset/scss/app.scss'
import 'swiper/dist/css/swiper.css'
import VuejsDialog from 'vuejs-dialog'
// import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js' // only needed in custom components

// include the default style
// import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// Tell Vue to install the plugin.
// Tell Vue to install the plugin.
Vue.use(VuejsDialog)
Vue.use(VueAwesomeSwiper)

export const render = (user) => {
  new Vue({
    router,
    store,
    render: h => h(Router),
    beforeCreate () {
      this.$store.commit('user', user)
    },
    mounted () {
      closeSpashscreen(this)
    }
  }).$mount('#app')
}
